import { TargetModeEditorOutput } from './target-mode-editor-output';

export const defaultTargetMode: TargetModeEditorOutput = {
  maxReservedWorkers: 1,
};
